module.exports = "<template>${ value | militaryTime }</template>\n";